import { Graphics } from 'pixi.js';

import { ClientGlobalSystem } from './ClientBase';

/**
 * Debug system that renders all active weapon swing hitboxes.
 */
export class DebugWeaponSwingRenderSystem extends ClientGlobalSystem {
  private graphics: Graphics | null = null;

  run(): void {
    const world = this.getWorld();
    // Re-use showAttackArcs debug flag (or we could add a new one)
    const showAttackArcs = this.clientServices.debug.state.showAttackArcs;

    // Create graphics if not exists
    if (!this.graphics) {
      this.graphics = new Graphics();
      this.graphics.zIndex = 100001; // Above collisions
      this.clientServices.render.stage?.addChild(this.graphics);
    }

    this.graphics.visible = showAttackArcs;
    this.graphics.clear();

    if (!showAttackArcs) return;

    // Query all entities with WeaponSwing and GlobalTransform
    const swings = world.query(['WeaponSwing', 'GlobalTransform', 'Hitbox'], []);

    for (const entityId of swings) {
      // Reconciliation: If this is a replicated swing for the local player,
      // and we have a predicted swing, don't show the replicated one.
      const swing = world.getComponent(entityId, 'WeaponSwing')!;
      const isPredicted = world.getComponent(entityId, 'IsPredicted');
      const localEntityId = this.clientServices.localPlayer.entityId;

      if (!isPredicted && swing.ownerEntityId === localEntityId) {
        // This is a replicated swing from the server for our own attack.
        // If we also have a predicted swing active, skip this one to avoid duplication.
        const activeSwings = world.query(['WeaponSwing', 'IsPredicted'], []);
        if (activeSwings.length > 0) continue;
      }

      const transform = world.getComponent(entityId, 'GlobalTransform')!;
      const hitbox = world.getComponent(entityId, 'Hitbox')!;

      this.graphics.beginPath();
      this.graphics.rect(
        transform.x + hitbox.offsetX,
        transform.y + hitbox.offsetY,
        hitbox.width,
        hitbox.height,
      );
      this.graphics.fill({ color: isPredicted ? 0x00ff00 : 0xffaa00, alpha: 0.3 });
      this.graphics.stroke({ color: isPredicted ? 0x00ff00 : 0xffaa00, alpha: 0.8, width: 1 });
    }
  }
}
